import { UserLicenseAgreementStatus } from "@kaggle/sdk/datasets";
import { DataSourceExtended } from "../types";
import { DataSourceType } from "@kaggle/sdk/datasets/databundles";

// Returns true for model instance version datasources that require the user
// to consent for a license agreement. Note, returns false for users that are
// are already pending approval or are an owner of the model.
export const RequiresLicenseAgreementConsent = (s: DataSourceExtended) => {
  if (s.sourceType !== DataSourceType.MODEL_INSTANCE_VERSION) {
    return false;
  }

  const licenseProto = s.modelInfo?.license;
  // Skip model instance versions that don't have a license proto. We should
  // probably throw an exception though - since all model instances must have a license.
  if (!licenseProto) {
    return false;
  }

  // Currently, only models with "agreement required licenses" can require additional
  // auth steps from the user.
  if (!licenseProto.agreementRequired) {
    return false;
  }

  // Check if the user has CanUse permissions regardless of their user license
  // agreement status (they're a model owner).
  const canUse = s.modelInfo?.canUse ?? false;
  if (canUse) {
    return false;
  }

  return (
    licenseProto.agreementStatus === UserLicenseAgreementStatus.UNSPECIFIED ||
    licenseProto.agreementStatus === undefined
  );
};
